var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgResults(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0887 1.01652C10.4431 0.23226 11.5569 0.23226 11.9113 1.01652L14.1086 5.87892C14.2541 6.20087 14.5587 6.42216 14.9098 6.46104L20.2133 7.04826C21.0686 7.14298 21.4128 8.20219 20.7765 8.7816L16.831 12.374C16.5698 12.6118 16.4535 12.9699 16.525 13.3158L17.6054 18.5412C17.7796 19.384 16.8786 20.0386 16.1309 19.6124L11.4952 16.9702C11.1882 16.7953 10.8118 16.7953 10.5048 16.9702L5.86909 19.6124C5.12139 20.0386 4.22037 19.384 4.39462 18.5412L5.47499 13.3158C5.54652 12.9699 5.43018 12.6118 5.16895 12.374L1.22355 8.7816C0.587191 8.20219 0.931351 7.14298 1.78674 7.04826L7.09017 6.46104C7.44133 6.42216 7.7459 6.20087 7.89139 5.87892L10.0887 1.01652Z",
    fill: "#2990FB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResults);
export default __webpack_public_path__ + "static/media/results.194c366958993ea7020ac09960c7289b.svg";
export { ForwardRef as ReactComponent };